import { PulseLoader } from '@sparemin/blockhead';
import React from 'react';
import { useIsEditorReady } from '../state';
import { block } from '../utils';

export type EditScenePreviewLoadingOverlayProps = {};

export const EditScenePreviewLoadingOverlay: React.FC<EditScenePreviewLoadingOverlayProps> = () => {
  const { isReady } = useIsEditorReady();

  return (
    !isReady && (
      <div className={block('preview-loading-overlay')}>
        <PulseLoader />
      </div>
    )
  );
};
